export function getPackageUrlSegment(pkg) {
  if (!pkg) return '';
  const slug = String(pkg.slug || '').trim();
  if (slug) return slug;
  return pkg.id;
}

export function findPackageByRouteParam(packages, routeParam) {
  if (!routeParam || !Array.isArray(packages)) return null;

  const normalized = String(routeParam).trim().toLowerCase();

  return packages.find((pkg) => {
    if (pkg.id === routeParam) return true;
    const slug = String(pkg.slug || '').trim().toLowerCase();
    return slug && slug === normalized;
  }) || null;
}
